import {GETSINGLECITY_CONTENT} from './actionTypes'

const initialState = {
  cityHtml: '',
  isLoadingForCity: false,
  hasErrorForCity: false,
  fulfilledForCity: false,
}

// export default (state = initialState, action) => {
//   switch (action.type) {
//     case GETSINGLECITY_CONTENT:
//       return {...state, cityHtml: action.payload, fulfilled: true}
//
//     default:
//       return state
//   }
// };

export default (state = initialState, action) => {
  switch (action.type) {
    case `${GETSINGLECITY_CONTENT}_PENDING`:
      return {
        ...state,
        fulfilledForCity: false,
        isLoadingForCity: true,
        hasErrorForCity: false,
        cityHtml: undefined,
      }

    case `${GETSINGLECITY_CONTENT}_FULFILLED`:
      return {
        fulfilledForCity: true,
        isLoadingForCity: false,
        hasErrorForCity: false,
        cityHtml: action.payload,
      }

    case `${GETSINGLECITY_CONTENT}_REJECTED`:
      return {
        fulfilledForCity: false,
        isLoadingForCity: false,
        hasErrorForCity: true,
        cityHtml: undefined,
      }

    default:
      return state
  }
}
